/**
 * Лёгкий helper для збереження UI-стану між навігаціями.
 *
 * sessionStorage — навмисно (а не localStorage), щоб:
 *   - стан зник при закритті вкладки (інакше user міг би заплутатись чому
 *     старий фільтр повернувся через тиждень)
 *   - не "забруднювати" квоту localStorage великими tree-структурами
 *   - зберігся при перехід між сторінками (як просив user)
 *
 * Використання:
 *   import { loadState, saveState } from '../lib/persisted-state';
 *   const saved = loadState<MyShape>('persons-list', { default... });
 *   // ... на onMount: відновити; на change: saveState('persons-list', curr)
 */

const PREFIX = 'mfy:ui:';

export function loadState<T>(key: string, fallback: T): T {
  if (typeof window === 'undefined') return fallback;
  try {
    const raw = sessionStorage.getItem(PREFIX + key);
    if (!raw) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function saveState<T>(key: string, value: T): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    // QuotaExceeded — просто ігноруємо (краще втратити стан ніж crash UI)
  }
}

export function clearState(key: string): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(PREFIX + key);
  } catch {
    /* noop */
  }
}
